import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { OverlayTrigger } from 'react-bootstrap';
import { popover } from '../../common/popover/popover';
import CardItem from '../../common/card/card';
import getCard from '../../common/drawCard/getCard';

import './MyHand.scss';

function MyHand() {
	const stateCards = useSelector((state) => state.hand.cards);
	const handActive = useSelector((state) => state.hand.handActive);

	useEffect(() => {
		getCard('myhand', 'card');
	}, [stateCards]);
	return (
		<OverlayTrigger placement="top" overlay={popover}>
			<div
				className="myhand"
				id="myhand"
				data-fair="true"
				data-active={handActive}
			>
				{stateCards.map((card, idx) => (
					<CardItem
						key={idx}
						id={card.id}
						handActive={handActive}
						card={card.card}
						suit={card.suit}
						disabled={card.disabled}
					/>
				))}
			</div>
		</OverlayTrigger>
	);
}

export default MyHand;
